<template>
  <b-modal
    v-model="showModal"
    title="Bill Details"
    size="xl"
    no-close-on-backdrop
    ok-only
    ok-title="Close"
    scrollable
    @ok="$emit('modal-closed')"
    @close="$emit('modal-closed')"
    @hidden="$emit('modal-closed')"
  >
    <b-alert
      variant="danger"
      :show="errorMessage ? true : false"
    >
      <div
        v-if="typeof errorMessage === 'object'"
        class="alert-body"
      >
        <p
          v-for="(message, index) in errorMessage"
          :key="index"
        >
          {{ message }}
        </p>
      </div>
      <p
        v-else
        class="alert-body"
      >
        {{ errorMessage }}
      </p>
    </b-alert>
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>
    <div v-if="!loading && !errorMessage">

      <div>
        <b-table-simple
          responsive
          hover
          class="compact-table"
        >
          <b-tbody>
            <b-tr>
              <b-th> Bill No </b-th>
              <b-td> {{ rgStatusDetails.invoice__bill_no }} </b-td>
              <b-th> Buyer </b-th>
              <b-td colspan="2">
                <span
                  v-if="rgStatusDetails.previous_bill_version_meta && rgStatusDetails.invoice__party__identifier !== rgStatusDetails.previous_bill_version_meta.party"
                  class="text-danger strike"
                >
                  {{ rgStatusDetails.previous_bill_version_meta.party }}
                </span>
                {{ rgStatusDetails.invoice__party__identifier }}
              </b-td>
              <b-td />
              <b-td />
              <b-td />
            </b-tr>
            <b-tr>
              <b-th> Status </b-th>
              <b-td> {{ rgStatusDetails.status }} </b-td>
              <b-th> Mode </b-th>
              <b-td>
                <span
                  v-if="rgStatusDetails.previous_bill_version_meta && rgStatusDetails.invoice__mode !== rgStatusDetails.previous_bill_version_meta.mode"
                  class="text-danger strike"
                >
                  {{ rgStatusDetails.previous_bill_version_meta.mode }}
                </span>
                {{ rgStatusDetails.invoice__mode }}
              </b-td>
              <b-th> Amount </b-th>
              <b-td colspan="3">
                <span
                  v-if="rgStatusDetails.previous_bill_version_meta && rgStatusDetails.invoice__amount !== rgStatusDetails.previous_bill_version_meta.amount"
                  class="text-danger strike"
                >
                  {{ rgStatusDetails.previous_bill_version_meta.amount }}
                </span>
                {{ rgStatusDetails.invoice__amount }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th> Packing Initiated By </b-th>
              <b-td>{{ rgStatusDetails.packing_initiated_by_actual || '-' }} </b-td>
              <b-th> Packing Initiated At </b-th>
              <b-td> {{ rgStatusDetails.packing_initiated_at ? formatedDate(rgStatusDetails.packing_initiated_at, 'DD-MM-YYYY LT') : '-' }} </b-td>
              <b-th> Packing Completed At </b-th>
              <b-td colspan="3">
                {{ rgStatusDetails.packing_completed_at ? formatedDate(rgStatusDetails.packing_completed_at, 'DD-MM-YYYY LT') : '-' }}
              </b-td>
            </b-tr>
            <template v-if="rgStatusDetails.bill_update_remarks && rgStatusDetails.bill_update_remarks.length > 0">
              <b-tr
                v-for="(remark, index) in rgStatusDetails.bill_update_remarks"
                :key="`remark-${index}`"
              >
                <b-th> Bill Modified By </b-th>
                <b-td>{{ remark.updated_by }}</b-td>
                <b-th> Bill Modified At </b-th>
                <b-td> {{ remark ? formatedDate(remark.created_at, 'DD-MM-YYYY LT') : '-' }} </b-td>
                <b-th> Modified Remarks </b-th>
                <b-td
                  colspan="3"
                  class="text-primary"
                >
                  {{ parseRemarks(remark.update_remark) }}
                </b-td>
              </b-tr>
            </template>
            <b-tr>
              <b-th> Attachments </b-th>
              <b-td colspan="7">
                <span
                  v-for="(item, index) in rgStatusDetails.bill_attachments"
                  :key="index"
                >
                  <a
                    :href="item.file"
                    target="_blank"
                  >
                    <span>View File {{ index+ 1 }} </span>
                    <span v-if="index != rgStatusDetails.bill_attachments.length - 1">, </span>
                  </a>
                </span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <b-tabs>
        <b-tab
          title="Bill Details"
          :active="mode === 'items'"
        >
          <b-table
            striped
            hover
            class="compact-table"
            :fields="tableColumns"
            :items="rgStatusDetails.invoice_items"
          />
        </b-tab>
        <b-tab
          title="Comparison Details"
          :active="mode === 'difference'"
        >
          <div
            id="content-holder"
            v-html="rgStatusDetails.difference_html"
          />
        </b-tab>
      </b-tabs>

    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BAlert, BTableSimple, BTr, BTh, BTd, BTbody, BTable, BTab, BTabs,
} from 'bootstrap-vue'
import axios from 'axios'

import dateMixin from '@/mixins/dateMixin'

export default {
  components: {
    BModal,
    BSpinner,
    BAlert,
    BTableSimple,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTable,
    BTab,
    BTabs,
  },
  mixins: [dateMixin],
  props: {
    id: { type: Number, required: true },
    mode: { type: String, default: 'items' },
  },
  data() {
    return {
      showModal: true,
      rgStatusDetails: {},
      loading: false,
      errorMessage: '',
      tableColumns: ['product', 'pack', 'rack_no', 'rack_group_no', 'rack_sub_group_no', 'quantity', 'batch', 'expiry', 'rate', 'mrp', 'company'],
    }
  },
  mounted() {
    this.fetchDifferenceDetails()
  },
  methods: {
    async fetchDifferenceDetails() {
      try {
        this.loading = true
        const { data } = await axios.get(`/operations/bill_rack_group_status/${this.$props.id}/`)
        this.rgStatusDetails = data
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to fetch details!'
      } finally {
        this.loading = false
      }
    },
    parseRemarks(remarkString) {
      try {
        // Simply remove the square brackets and keep everything else as is
        return remarkString.replace(/^\[|\]$/g, '')
      } catch (error) {
        // If parsing fails, return the original string
        return remarkString
      }
    },
  },
}
</script>

<style scoped>
.strike {
  text-decoration: line-through;
  display: inline-block;
}
</style>
